import axios from 'axios'
import { config } from '../config';

export async function sendEmail(userId, emailType) {
    const response = await axios.get(config.IDENTITY_URL + 'api/user/sendemail?userId=' + userId + '&emailType=' + emailType, { withCredentials: true });
    return response.data;
}